import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { timer, Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { OpenIdConnectService } from '../../services/oidc/open-id-connect.service';

@Component({
    selector: 'app-session-timeout',
    templateUrl: './session-timeout.component.html',
    styleUrls: ['./session-timeout.component.css']
})
export class SessionTimeoutComponent implements OnInit {
    secondsLeft: number;
    countDown: Observable<number>

    get timeLeft(): string {
        var minutes = Math.ceil(this.secondsLeft / 60);
        
        return minutes > 1 ? `${minutes} minutes` : `${this.secondsLeft} second${this.secondsLeft == 1 ? "" : "s"}`;
    }

    constructor(dialogRef: MatDialogRef<SessionTimeoutComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private oidcService: OpenIdConnectService) {
        this.secondsLeft = data.timer;
        this.countDown = timer(0, 1000)
        this.countDown.subscribe(val => {
            this.secondsLeft -= 1;

            if (this.secondsLeft == 0) {
                dialogRef.close(false);
            }
        });
    }

    ngOnInit() {
    }

}
